import { defineStore } from 'pinia';

export enum ViewerMode {
  VIDEO = 'video',
  SUMMARY = 'summary',
  LOGS = 'logs',
}

export enum ViewerLayoutDefault {
  LET_ZIGHT_DECIDE = 'let_zight_decide',
}

/**
 * Tracks which viewer mode the user is in.
 *
 * Logs availability is NOT stored here — it's derived from
 * `useArtifactsStore.insightsURL` via `useViewerAvailableModes`.
 *
 * Viewport size is also NOT stored here — `useViewerAvailableModes` combines
 * mobile detection with logs availability to compute `availableModes`.
 */
export const useViewerModeStore = defineStore('viewerMode', {
  state: () => ({
    currentMode: ViewerMode.VIDEO,
  }),

  getters: {
    isVideoMode: state => state.currentMode === ViewerMode.VIDEO,
    isSummaryMode: state => state.currentMode === ViewerMode.SUMMARY,
    isLogsMode: state => state.currentMode === ViewerMode.LOGS,
  },

  actions: {
    setMode(mode: ViewerMode) {
      this.currentMode = mode;
    },
  },
});
